import React from "react"
import Helmet from "react-helmet"
import Layout from "../components/layout"
import Faq from "../components/Faq/"
import VisualSlider from "../components/VisualSlider/"
import Oferta from "../components/Home/oferta"
import SEO from "../components/seo"
import '../sass/main.scss'
import SideLadowarki from "../components/Home/side-ladowarki"
import SideMapa from "../components/Home/side-mapa"
import NewsList from "../components/News/newslist"
import Aplikacja from "../components/Home/aplikacja"
import ModalBaner from "../components/Modals/ModalBaner"

const ComponentName = () => {
  const [modBanerShow, setModBanerShow] = React.useState(true)
  return (
    <Layout>
      <SEO />
      <Helmet>
        <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="44719b8e-7ef3-4ba2-bf07-905ed880b350" data-blockingmode="auto" type="text/javascript"></script>
      </Helmet>
      <VisualSlider />
      <Oferta />

      <section className="sidebyside" id="stations-map">
        <div className="row no-gutters">
          <SideLadowarki />
          <SideMapa />
        </div>
      </section>

      <Aplikacja />
      <NewsList />

      <Faq />
      <ModalBaner show={modBanerShow} handleclose={() => setModBanerShow(false)} />
    </Layout>
  )
}

export default ComponentName

